import Vue from "vue";
import App from "./components/App";
import "./index.css";
import store from "./store";
import router from "./router";
import i18n from "./i18n";

import "whatwg-fetch";

Vue.config.productionTip = false;

new Vue({
    store,
    router,
    i18n,
    render: h => h(App),
}).$mount("#app");
